export default __webpack_public_path__ + "static/media/Medina.575d52b6.mp4";